// extracted by mini-css-extract-plugin
module.exports = {"button_done":"button_done-3e7T6","button_clear":"button_clear-397s3","dialog__content":"dialog__content-2WIjM"};